import React from 'react';
import logo from 'auslfe-theme/components/Layout/images/logo.svg?width=85';
import { SiteProperty } from 'volto-site-settings';

const Logo = ({ alt = 'Logo' }) => {
  return (
    <SiteProperty
      property="site_logo"
      defaultValue={{ url: logo, width: 82, height: 82 }}
      className="icon"
      alt={alt}
    />
  );
};
export default Logo;
